<div class="body">

    <div class="container" style="height:100px"> </div>

    <div class="container principal">
        <div class="col-lg-12">
          
            <p><b>Manual de becas: </b> <a
                    href="{{this.linkTexto}}"
                    target="_blank">
                    Beca</a>.</p>
        </div>
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-8"> </div>

                <div class="col-lg-4">
                    <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                </div>

            </div>

        </div>

        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h1> Rut Afiliado </h1>
                </div>

                <div class="col-lg-6">

                    <input id="txt_rut" name="afiliado" [(ngModel)]="beca.afiliado" #afiliado="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida" (click)="ingresaAfiliado()" [disabled]="afiliado.invalid ">

                        Buscar

                    </button>

                </div>

                <div class="col-lg-1"> </div>

            </div>

        </div>

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-4">
                <h1> Becas </h1>
            </div>

            <div class="col-lg-4"> </div>

        </div>

        <hr/> <br/>

        <form #becaForm=ngForm>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2"> <label>Tipo de Beca</label> </div>

                <div class="col-lg-8">

                    <div class="form-group">

                        <select id="tipoBeca" name="tipoBeca" class="form-control" required [(ngModel)]="beca.tipoBeca" #tipoBeca="ngModel" (change)="seleccionaTipoBeca()" no>

                            <option *ngFor = "let tipo of tiposBeca" value = {{tipo.id}}> {{tipo.descripcion}} </option>

                        </select>

                    </div>

                    <div *ngIf="tipoBeca.errors && tipoBeca.touched" class="alert alert-danger">

                        <div *ngIf="tipoBeca.errors.required"> Seleccione Tipo de Beca. </div>

                    </div>

                </div>

            </div> <br/> <br/>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h2> Beneficiarios </h2>
                </div>

                <div class="col-lg-9">

                </div>

            </div>
            <hr/>

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Parentesco </th>

                            <th scope="col"> Edad </th>

                            <th scope="col"> Sexo </th>

                            <th scope="col"> Seleccionar </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulante of postulantes; let i = index">

                            <td> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                            <td> {{postulante.parentesco}} </td>

                            <td> {{postulante.fechaNacimiento}} </td>

                            <td> {{postulante.sexo.nombre}} </td>

                            <td>

                                <input type="radio" name="postulante" [(ngModel)]="beca.postulante" value="{{postulante.rut + '-' + postulante.id + '-' + postulante.parentesco
                                + '-' + postulante.nombres + ' ' + postulante.apellidoPaterno}}" [attr.disabled]="seleccionPostulante ? true : null" required (click)="beneficiarioEtapaEscolar(postulante.parentesco)">

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div> <br/> <br/>


            <div class="row">

                <div class="col-lg-1 col-xs-1"> </div>

                <div class="col-lg-3 col-xs-5">
                    <h2> Otros Datos </h2>
                </div>

                <div class="col-lg-1 col-xs-5"> </div>

            </div> <br/>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2"> <label> Etapa Escolar </label> </div>

                <div class="col-lg-8">

                    <div class="form-group">

                        <select name="curso" class="form-control" required [(ngModel)]="beca.curso" #curso="ngModel">

                            <option *ngFor = "let curso of cursos" value = "{{curso.id + '-' + curso.descripcion + '-' + curso.calificacionMinima}}">

                                {{curso.descripcion}}

                            </option>

                        </select>

                    </div>

                    <div *ngIf="curso.errors && curso.touched" class="alert alert-danger">

                        <div *ngIf="curso.errors.required"> Seleccione Etapa Escolar. </div>

                    </div>

                </div>

            </div> <br/>

            <div class="row line" *ngIf="excelencia">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <p>Calificación</p>
                </div>

                <div class="col-lg-5" *ngIf="excelencia">

                    <input class="form-control" name="nota" placeholder="Ingrese con 3 decimales separados por punto" pattern="[1-7]{1}[.]{1}[0-9]{3}" [(ngModel)]="beca.nota" #nota="ngModel" required>

                    <div *ngIf="nota.invalid && (nota.dirty || nota.touched) && nota.errors.pattern" class="alert alert-danger" style="z-index: 5;">

                        <div> El patrón definido es 7.777 </div>

                    </div>

                </div>

                <div class="col-lg-4"> </div>

            </div>

            <div class="row line" *ngIf="solicitaDiagnostico">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">

                    <p> Diagnóstico </p>

                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="diagnostico" required #diagnostico="ngModel" [(ngModel)]="beca.diagnostico" placeholder="Ingrese Diagnóstico">

                </div>

                <div class="col-lg-4"> </div>

            </div>

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest" (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"> </div>

            </div>

            <div *ngIf="cantidadArchivos > 1" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (2) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo2" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest2" (change)="seleccionaArchivo($event, 1)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="cantidadArchivos > 2" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (3) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo3" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest3" (change)="seleccionaArchivo($event, 2)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (4) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo4" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest4" (change)="seleccionaArchivo($event, 3)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest5" (change)="seleccionaArchivo($event, 4)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div *ngIf="cantidadArchivos > 5" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (6) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo6" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="beca.archivoTest6" (change)="seleccionaArchivo($event, 5)">

                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"> <button class="btn btn-danger" (click)="salir()"> Salir </button> </div>

                <div class="col-lg-3 col-sm-1">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class="btn btn-success" (click)="solicitar(becaForm)" [disabled]="becaForm.invalid">

                        Solicitar

                    </button>
                    </div>
                </div>

                <div class="col-lg-1 col-sm-1"> </div>

            </div>

        </form>

    </div>

    <div class="container" style="height:100px"> </div>

</div>